import React from "react";
import DashboardWidgetContainer from "../../../containers/DashboardWidget/DashboardWidgetContainer";
import {
  ListItem,
  ListItemText,
  ListItemIcon,
  Typography,
  Divider,
  List
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import ResourceTypeIcon from "../../Icons/ResourceTypeIcon";
import { withRouter } from "react-router-dom";
import { widgetKeys } from "../../../constants";
import { useTranslation } from "react-i18next";
import { viewDashboardWidgets } from "../../../constants";
import { resources as learningCenterResourcesRoute } from "../../../routes/LearningCenterRoutes";
import { resources as adminConsoleResourcesRoute } from "../../../routes/AdminRoutes";

const resourcesRoute = {
  [viewDashboardWidgets.contentTools]: adminConsoleResourcesRoute,
  [viewDashboardWidgets.learningCenter]: learningCenterResourcesRoute
};

const useStyles = makeStyles(theme => ({
  listItem: {
    padding: theme.spacing(1, 2, 1, 1)
  },
  divider: {
    marginLeft: theme.spacing(6)
  },
  list: {
    paddingBottom: 1,
    flex: 1,
    overflowY: "auto",
    minHeight: 216
  },
  icon: {
    paddingRight: theme.spacing(2)
  }
}));

const ResourcesListItems = ({ resources, history, dashboard }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const handleResourceClicked = React.useCallback(
    resource => event => {
      history.push(`${resourcesRoute[dashboard]}#${resource.id}`);
    },
    [history]
  );

  if (!resources || resources.length === 0) {
    return (
      <Typography variant="subtitle1" color="textPrimary">
        {t("resources.none")}
      </Typography>
    );
  } else {
    return resources.map((resource, index) => (
      <React.Fragment key={index}>
        <ListItem
          button
          alignItems="center"
          classes={{ root: classes.listItem }}
        >
          <ListItemIcon className={classes.icon}>
            <ResourceTypeIcon type={resource.type} />
          </ListItemIcon>
          <ListItemText
            onClick={handleResourceClicked(resource)}
            primary={
              <Typography variant="subtitle1" color="textPrimary">
                {resource.name}
              </Typography>
            }
          />
        </ListItem>
        <Divider variant="inset" component="li" className={classes.divider} />
      </React.Fragment>
    ));
  }
};

const Resources = ({ resources, history, currentUser, dashboard }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const handleMenuItemClick = React.useCallback(
    menuItem => {
      if (menuItem.value === "view") {
        history.push(resourcesRoute[dashboard]);
      }
    },
    [history]
  );

  const renderMenuOptions = currentUser => {
    return [{ value: "view", label: t("resources.options.view") }];
  };

  return (
    <DashboardWidgetContainer
      dashboard={dashboard}
      widgetKey={widgetKeys.resources}
      title="Resources"
      menuProps={{
        options: renderMenuOptions(currentUser),
        onMenuItemClick: handleMenuItemClick
      }}
    >
      <List className={classes.list}>
        <ResourcesListItems
          resources={resources}
          history={history}
          dashboard={dashboard}
        />
      </List>
    </DashboardWidgetContainer>
  );
};

export default withRouter(Resources);
